import React from "react";
import { FullPageLayout } from "../../components/FullPageLayout";
import { useDispatchData } from "./useDispatchData";
import useAuth from "../../hooks/useAuth";
import toast from "react-hot-toast";
import { Button, Spinner } from "react-bootstrap";

export function DispatchTray() {
    const {
        selectedDate, setSelectedDate, mode, setMode,
        dispatches, totals, selectedId, selectedOrder, setSelectedId,
        detailItems, loading, detailLoading, error, refresh
        , updateDispatchStatus, updating } = useDispatchData();
    const { user } = useAuth();

    return (
        <>
            <header>
                <header style={{ display: "flex", gap: 12, alignItems: "center", marginBottom: 12 }}>
                    <input type="date" value={selectedDate} onChange={e => setSelectedDate(e.target.value)} />
                    <div>
                        <label style={{ marginRight: 8 }}>
                            <input type="radio" checked={mode === "orders"} onChange={() => setMode("orders")} /> Órdenes
                        </label>
                        <label>
                            <input type="radio" checked={mode === "totals"} onChange={() => setMode("totals")} /> Totales
                        </label>
                    </div>
                    <Button variant="outline-primary" size="sm" onClick={refresh}>Refrescar</Button>
                </header>
            </header>

            <main>
                {error && <div style={{ color: "red" }}>{error}</div>}
                {mode === "orders" ? (
                    <section>
                        {loading ? <div>Cargando despachos…</div> : null}
                        {!loading && dispatches.length === 0 && <div>No hay despachos confirmados para la fecha seleccionada.</div>}
                        <ul>
                            {dispatches.map(d => {
                                // determine background color based on dispatchStatus
                                let backgroundColor: string | undefined = undefined;
                                if (d.dispatchStatus === "in_progress") backgroundColor = "#fff9c4"; // light yellow
                                if (d.dispatchStatus === "completed") backgroundColor = "#ffcdd2"; // light red

                                return (
                                    <li key={d.id} onClick={() => setSelectedId(d.id)} style={{ cursor: "pointer", padding: 8, backgroundColor }}>
                                        <div>
                                            <strong>
                                                {d.sellerName}
                                                {d.dispatchStatus !== "pending" && d.packedByName ? ` [${d.packedByName}]` : null}
                                            </strong>
                                        </div>
                                        <div>{d.clientName}</div>
                                    </li>
                                );
                            })}
                        </ul>
                    </section>
                ) : (
                    <section>
                        {loading ? <div>Cargando totales…</div> : null}
                        <ul>
                            {totals.map(t => (
                                <li key={t.productId}>{t.name} — {t.totalQty}</li>
                            ))}
                        </ul>
                    </section>
                )}

                {selectedId && (
                    <div role="dialog" aria-modal="true" style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.4)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div style={{ background: "#fff", padding: 16, minWidth: 320 }}>
                            {/* modal header: left controls and right packedByName */}
                            <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12 }}>
                                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                                    <Button variant="secondary" size="sm" onClick={() => setSelectedId(null)}>Cerrar</Button>
                                    {/* status action buttons */}
                                    {selectedOrder?.dispatchStatus === "pending" && (
                                        <Button variant="primary" size="sm" disabled={updating} onClick={async () => {
                                            if (!selectedId) return;
                                            try {
                                                await updateDispatchStatus(selectedId, "in_progress", user?.id || null);
                                                toast.success("Despacho en alistamiento");
                                            } catch (err: any) {
                                                console.error(err);
                                                toast.error(err?.message || "Error al iniciar alistamiento");
                                            }
                                        }}>
                                            {updating ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Iniciar alistamiento</> : 'Iniciar alistamiento'}
                                        </Button>
                                    )}
                                    {selectedOrder?.dispatchStatus === "in_progress" && (
                                        <>
                                            <Button variant="warning" size="sm" disabled={updating} onClick={async () => {
                                                if (!selectedId) return;
                                                try {
                                                    await updateDispatchStatus(selectedId, "pending", null);
                                                    toast.success("Despacho dejado en pendiente");
                                                } catch (err: any) {
                                                    console.error(err);
                                                    toast.error(err?.message || "Error al dejar pendiente");
                                                }
                                            }} style={{ marginRight: 8 }}>
                                                {updating ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Dejar pendiente</> : 'Dejar pendiente'}
                                            </Button>
                                            <Button variant="success" size="sm" disabled={updating} onClick={async () => {
                                                if (!selectedId) return;
                                                try {
                                                    await updateDispatchStatus(selectedId, "completed", user?.id || null);
                                                    toast.success("Despacho completado");
                                                } catch (err: any) {
                                                    console.error(err);
                                                    toast.error(err?.message || "Error al completar");
                                                }
                                            }}>
                                                {updating ? <><Spinner as="span" animation="border" size="sm" role="status" aria-hidden="true" /> Completar</> : 'Completar'}
                                            </Button>
                                        </>
                                    )}
                                </div>
                                <div style={{ textAlign: "right" }}>
                                    {selectedOrder?.dispatchStatus !== "pending" && selectedOrder?.packedByName ? (
                                        <div><strong>{selectedOrder.packedByName}</strong></div>
                                    ) : null}
                                </div>
                            </div>

                            <h4 style={{ marginTop: 12 }}>Detalle despacho {selectedId} [{selectedOrder?.sellerName}]</h4>
                            <h3>{selectedOrder?.clientName}</h3>
                            {detailLoading && <div>Cargando detalle…</div>}
                            {!detailLoading && detailItems && (
                                <ul>
                                    {detailItems.map(p => <li key={p.id}>{p.name} — {p.qty}</li>)}
                                </ul>
                            )}
                            {!detailLoading && !detailItems && <div>No se pudo cargar el detalle.</div>}
                        </div>
                    </div>
                )}
            </main>
        </>
    )
}

function DispatchTrayPage() {



    return (
        <FullPageLayout>
            <DispatchTray />
        </FullPageLayout>
    );
}

export default DispatchTrayPage;